import { z } from "zod";

export const TraceElementSchema = z.object({
  artifactId: z.string(),
  path: z.string(),
  symbolId: z.string().optional(),
  kind: z.enum(["file", "symbol"]),
});

export type TraceElement = z.infer<typeof TraceElementSchema>;

export const TraceConnectionSchema = z.object({
  from: TraceElementSchema,
  to: TraceElementSchema,
  confidence: z.number().min(0).max(1),
  resolver: z.string(),
});

export type TraceConnection = z.infer<typeof TraceConnectionSchema>;

export const ResolvedTraceLinkSchema = z.object({
  id: z.string(),
  from: z.string(),
  to: z.string(),
  resolver: z.string(),
  description: z.string().optional(),
  connections: z.array(TraceConnectionSchema),
  orphans: z.object({
    from: z.array(TraceElementSchema),
    to: z.array(TraceElementSchema),
  }),
});

export type ResolvedTraceLink = z.infer<typeof ResolvedTraceLinkSchema>;

export const TraceabilityReportSchema = z.object({
  system: z.string(),
  links: z.array(ResolvedTraceLinkSchema),
  summary: z.object({
    totalLinks: z.number().int().nonnegative(),
    fullyConnected: z.number().int().nonnegative(),
    partiallyConnected: z.number().int().nonnegative(),
    disconnected: z.number().int().nonnegative(),
  }),
  orphanElements: z.array(TraceElementSchema),
  generatedAt: z.string(),
});

export type TraceabilityReport = z.infer<typeof TraceabilityReportSchema>;
